import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogActions } from '../Dialog/Dialog';
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { logoutUser } from "../../../store/actions/authActionCreators";
import { withRouter, useHistory } from 'react-router-dom';
import useStyles from '../../pages/css/forms';
import { type } from 'jquery';
import { driverAdditionType, driverDeductionType, addShopTransaction, driverAddTranscationType, editShopTransaction, fetchSingleShopAndTransaction } from "../../../store/actions/vehicleActionCreator";
import NotesIcon from '@material-ui/icons/Notes';
import DateFnsUtils from '@date-io/date-fns';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Divider from '@material-ui/core/Divider';
import * as logger from '../../../logger';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { getDriverLedger } from '../../../store/actions/homeActionCreator';
import { DialogTitle } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { replaceCommas, numberWithCommas, isEmpty, checkNumberOnly, numberWithCommasInput } from '../../../utils/utils';
import AmountInput from '../Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { trackDwebEvent } from '../../analytics';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
// function sleep(delay = 0) {
//     return new Promise((resolve) => {
//         setTimeout(resolve, delay);
//     });
// }

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const filter = createFilterOptions();

const ShopCreditAndPayment = ({ props, dispatchGetSingleShopAndTransaction, editData, defaultName, fromSingleDriver, dispatchEditTransaction, balanceType, dispatchAddShopTransactions, dispatchFetchAllDrivers, dispatchGetDriverAdditionTypes, dispatchGetDriverDeductionTypes, onConfirm, onOpen, onClose, onSave, vehicle, dispatchAddNewDriver, shopId, fromDriverListing, user, dispatchAddTransactionType, onEdit }) => {

    let submit;
    const [driverAdditionTypeList, setDriverAdditionTypeList] = useState([]);
    const [driverDeductionTypeList, setDriverDeductionTypeList] = useState([]);
    const [dialogopen, setDialogOpen] = React.useState(onOpen);
    const [open, setOpen] = React.useState(false);
    const [addDriverOpen, toggleAddReasonOpen] = React.useState(false);
    const [reasonValue, setReasonValue] = useState("");
    const [recall, setRecall] = useState(false);
    const [singleTransactionData, setSingleTransactionData] = useState({});
    const [disable, setDisable] = useState(false);
    const [amountValue, setAmountValue] = useState('');
    const [dataFlag, setDataFlag] = useState(false);
    const [dateValue, setDateValue] = useState(null);
    const shopDataValue = {
        pageNo: defaultPageNo,
        pageSize: defaultPageSize
    }
    const initialValues = {
        date: dateValue ? dateValue : singleTransactionData && singleTransactionData.date ? new Date(singleTransactionData.date * 1000) : new Date(),
        amount: amountValue ? amountValue : singleTransactionData && singleTransactionData.amount ? numberWithCommas(singleTransactionData.amount) : amountValue,
        //amount: singleTransactionData && singleTransactionData.amount ?numberWithCommas(singleTransactionData.amount):editData && editData.amount ?numberWithCommas(Math.abs(editData.amount)):amountValue,
        reason: reasonValue ? reasonValue : singleTransactionData && singleTransactionData.description ? singleTransactionData.description : reasonValue,
    }

    const classes = useStyles();
    useEffect(() => {
        if (balanceType == "Credit") {
            trackDwebEvent('Dweb Single Shop credit initiated', {
                shop_id: shopId,
                shop_name: vehicle && vehicle.singleShopData && vehicle.singleShopData.name ? vehicle.singleShopData.name : '',
                contact_number: vehicle && vehicle.singleShopData && vehicle.singleShopData.contactNumber ? vehicle.singleShopData.contactNumber : '',
                balance: vehicle && vehicle.singleShopData && vehicle.singleShopData.balance ? vehicle.singleShopData.balance : '',
            });
        }
        if (balanceType == "Payment") {
            trackDwebEvent('Dweb Single Shop Payment initiated', {
                shop_id: shopId,
                shop_name: vehicle && vehicle.singleShopData && vehicle.singleShopData.name ? vehicle.singleShopData.name : '',
                contact_number: vehicle && vehicle.singleShopData && vehicle.singleShopData.contactNumber ? vehicle.singleShopData.contactNumber : '',
                balance: vehicle && vehicle.singleShopData && vehicle.singleShopData.balance ? vehicle.singleShopData.balance : '',
            });
        }
    }, []);

    useEffect(() => {

        if (onEdit) {
            setSingleTransactionData(vehicle.singleShopTransaction);
        }

    }, [vehicle.singleShopTransaction, onEdit]);

    useEffect(() => {

        if (editData) {
            setDateValue(editData.date ? new Date(editData.date * 1000) : new Date());
            setAmountValue(editData.amount ? numberWithCommas(Math.abs(editData.amount)) : 0);
            setReasonValue(editData.description ? editData.description : "");
        }

    }, [editData]);

    const handleClose = (status) => {
        onClose(false);
        var form = document.getElementById('myForm');
        form.reset();
    };

    const onSubmit = async values => {

        await sleep(300);

        if (onEdit) {


            let id;

            if (editData && editData.id) {
                id = editData.id
            }
            var data = {
                id: id,
                amount: replaceCommas(values.amount),
                date: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                description: values.reason ? values.reason : "",
            }
            if (balanceType == "Credit") {
                data.amount = -Math.abs(data.amount);
            }
            dispatchEditTransaction(shopId,
                data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Single Shop Component", "Edit Shop transaction successfull");
                        dispatchGetSingleShopAndTransaction(shopId, shopDataValue,
                            () => {
                                onConfirm();
                                logger.log("singleDriverComponent", "Single Driver Fetch Successfull");
                            },
                            () => {
                                onConfirm();
                                logger.log("singleDriverComponent", "Single Driver Fetch Failed");
                            }
                        )
                    }
                },
                () => {
                    logger.log("Single Shop Component", "Edit Shop transaction failed");
                }
            )

        } else {

            var data = {
                id: shopId,
                amount: replaceCommas(values.amount),
                date: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                description: values.reason ? values.reason : "",
            }

            if (balanceType == "Credit") {
                data.amount = -Math.abs(data.amount);
            }
            dispatchAddShopTransactions(data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        trackDwebEvent(`Dweb Single Shop ${balanceType} Created`, {
                            shop_id: shopId,
                            shop_name: vehicle && vehicle.singleShopData && vehicle.singleShopData.name ? vehicle.singleShopData.name : '',
                            contact_number: vehicle && vehicle.singleShopData && vehicle.singleShopData.contactNumber ? vehicle.singleShopData.contactNumber : '',
                            balance: vehicle && vehicle.singleShopData && vehicle.singleShopData.balance ? vehicle.singleShopData.balance : '',
                            amount: replaceCommas(values.amount),
                            date: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                            reason: values.reason ? values.reason : "",
                        });
                        logger.log("Shop Component Dialog Dweb ", "Successfull");
                        setDialogOpen(false);
                        dispatchGetSingleShopAndTransaction(shopId, shopDataValue,
                            () => {
                                onConfirm();
                            },
                            () => {
                                onConfirm();
                            }
                        )
                    }
                },
                () => {
                    trackDwebEvent(`Dweb Single Shop ${balanceType} Failed`, {
                        shop_id: shopId,
                        shop_name: vehicle && vehicle.singleShopData && vehicle.singleShopData.name ? vehicle.singleShopData.name : '',
                        contact_number: vehicle && vehicle.singleShopData && vehicle.singleShopData.contactNumber ? vehicle.singleShopData.contactNumber : '',
                        balance: vehicle && vehicle.singleShopData && vehicle.singleShopData.balance ? vehicle.singleShopData.balance : '',
                        amount: replaceCommas(values.amount),
                        date: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
                        reason: values.reason ? values.reason : "",
                    });
                    logger.log("Shop Component Dialog Dweb", "Failed");
                }
            );
        }
    }


    const validate = async values => {

        await sleep(100)

        const errors = {};

        if (values.amount && !checkNumberOnly(replaceCommas(values.amount)) || !values.amount) {
            errors.amount = "Please enter valid amount"
        }
        if (!values.reason) {
            errors.reason = "Please enter reason"
        }
        if (!values.date) {
            errors.date = "Please select date"
        }
        if (isEmpty(errors)) {
            setDataFlag(false)
        } else {
            setDataFlag(true)
        }
        return errors;
    }
    return (
        <Dialog fullWidth={true}
            maxWidth='xs'
            onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogopen}>
            <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                <div className={classes.divV20}>
                    {balanceType == "Credit" &&
                        <div>{onEdit ? "Edit" : "Add"} Shop Credit</div>
                    }
                    {balanceType == "Payment" &&
                        <div>{onEdit ? "Edit" : "Add"} Shop Payment</div>
                    }
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent dividers className={classes.dialogContentV1}>
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validate}
                    render={({ handleSubmit, form, submitting, pristine, values }) => {
                        submit = handleSubmit
                        return (
                            <form
                                onSubmit={(event) => {
                                    const promise = handleSubmit(event);
                                    // promise && promise.then(() => {
                                    //     form.reset();
                                    // })
                                    return promise;
                                }} id="myForm" noValidate>
                                <div className={classes.divAmount} >{balanceType} Amount*</div>
                                <AmountInput
                                    // label="Amount"
                                    placeholder={balanceType + " Amount"}
                                    name="amount"
                                    variant="outlined"
                                    size="small"
                                    required={true}
                                    onChange={(e) => { setAmountValue(e.target.value) }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end"> &#x20B9;</InputAdornment>,
                                    }}
                                    fieldProps={{
                                        // parse: value => value && numberWithCommas(value)
                                    }}
                                    className={classes.marginV1}
                                />

                                <div className={classes.divReason}>{balanceType} Reason*</div>
                                <TextField
                                    // label="Note"
                                    onChange={(e) => { setReasonValue(e.target.value) }}
                                    placeholder={"Enter a Reason for " + balanceType}
                                    name="reason"
                                    //margin="none"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        className: classes.marginV2,
                                        //startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>,
                                    }}

                                />

                                <div className={classes.divDate}>{balanceType} Date*</div>
                                <DatePicker
                                    disableFuture
                                    name="date"
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    format="dd-MM-yyyy"
                                    // label="Date"
                                    placeholder="Select Date"
                                    dateFunsUtils={DateFnsUtils}
                                    value={dateValue}
                                    onChange={date => setDateValue(date)}
                                    InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                    className={classes.marginV1}
                                />



                                <Divider className={classes.mtV1} />

                            </form>
                        )
                    }}
                />

                {/* <Button color="primary" onClick={() => {
                    document.getElementById('myForm')
                        .dispatchEvent(new Event('submit', { cancelable: true }))
                }}>Submit</Button> */}

                <div className={classes.divV7}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                        disabled={dataFlag}
                    >
                        Save
                    </Button>
                </div>

            </DialogContent>
        </Dialog>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleShopAndTransaction: (id, data, onSuccess, onFailure) => {
        dispatch(fetchSingleShopAndTransaction(id, data, onSuccess, onFailure));
    },
    dispatchGetDriverAdditionTypes: (onSuccess, onFailure) => {
        dispatch(driverAdditionType(onSuccess, onFailure))
    },
    dispatchGetDriverDeductionTypes: (onSuccess, onFailure) => {
        dispatch(driverDeductionType(onSuccess, onFailure));
    },
    dispatchAddShopTransactions: (data, onSuccess, onFailure) => {
        dispatch(addShopTransaction(data, onSuccess, onFailure))
    },
    dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedger(data, onSuccess, onFailure))),
    dispatchAddTransactionType: (data, onSuccess, onFailure) => {
        dispatch(driverAddTranscationType(data, onSuccess, onFailure));
    },
    dispatchEditTransaction: (id, data, onSuccess, onFailure) => {
        dispatch(editShopTransaction(id, data, onSuccess, onFailure))
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShopCreditAndPayment);
